import React from 'react'
import {Form, Input} from "antd";

const CustomerFilter = () => {

    return(
        <React.Fragment>
            <Form.Item
                name={'name'}
                label={'Müşteri Adı'}
                initialValue={''}
            >
                <Input />
            </Form.Item>
            <Form.Item
                name={'address'}
                label={'Adres'}
                initialValue={''}
            >
                <Input />
            </Form.Item>
        </React.Fragment>
    )
}
export default CustomerFilter